import React from "react";
import {
  CssBaseline,
  Container,
  Box,
  Typography,
  Button,
  useMediaQuery,
} from "@mui/material";
import QR from "../assets/img/QR.png.jpeg"
import { useNavigate } from "react-router-dom";
// import { display } from "html2canvas/dist/types/css/property-descriptors/display";

const HomePage = () => {
  const navigate = useNavigate();
  const isMobile = useMediaQuery("(max-width:600px)");

  const goLoginPage = () => {
    navigate("/");
  };

  return (
    <>
      {/* <CssBaseline /> */}
      {/* Inline styles for background image */}
      <style>
        {`
    body {
      margin: 0;
      padding: 0;
      overflow: hidden;
      color: white;
      background: url('https://img.freepik.com/free-photo/qr-code-restaurant-menu_23-2150384761.jpg?semt=ais_hybrid') no-repeat center center fixed;
      background-size: 100% 100%; /* Stretches the image to fit */
    }
    html, body {
      width: 100%;
      height: 100%;
    }
  `}
      </style>

      <Box sx={{ display: "flex", textAlign: "center", height: "1000px" }}>
        <Box mb={5} sx={{ padding: "200px 20px 20px 20px" }}>
          <Typography variant="h4" gutterBottom sx={{ color: "white" }}>
            QR Code Payment
          </Typography>
          <Typography variant="body1" color="white">
            Your payment was 30 days ago. Make the payment through the QR code below to access the application.
          </Typography>
          <Box>
            <Typography variant="body1" sx={{ mb: 2, color: "white" }}>
              Scan the QR code using your preferred payment app.
            </Typography>

            {/* <Button

              size="large"
              onClick={goLoginPage}
              sx={{
                border: "1px solid #e0e0e0",
                borderRadius: 2,
                boxShadow: 3,
                backdropFilter: "blur(10px)",
                color: "white"
              }}

            >
              Back to Login
            </Button> */}
            <Button
              size="large"
              onClick={goLoginPage}
              sx={{
                border: "1px solid #e0e0e0",
                borderRadius: 2,
                boxShadow: 3,
                backdropFilter: "blur(10px)",
                color: "white",
                textTransform:"none",
                animation: "pulse 2s infinite", // Continuous animation
                "@keyframes pulse": {
                  "0%, 100%": {
                    transform: "scale(1)", // Original size
                  },
                  "50%": {
                    transform: "scale(1.1)", // Slightly larger size
                  },
                },
              }}
            >
              Back to Login
            </Button>

          </Box>
        </Box>
        <Box sx={{ paddingLeft: "70px" }}>
          <Box
            sx={{
              p: 1,
              width: "380px",
              height: "400px",
              display: "flex", // Use flexbox to align items
              flexDirection: "column", // Stack items vertically
              alignItems: "center", // Center items horizontally
              background: "#FF9D23",
              borderRadius: "20px",
              marginTop: "200px",


            }}
          >
            <Box
              sx={{
                // mb: 2,
                width: isMobile ? "100px" : "250px",
                height: isMobile ? "100px" : "250px",
                overflow: "hidden",
                marginTop: "10px"
              }}
            >
              <img
                src={QR}
                alt="QR Code"
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  display: "block",
                }}
              />
            </Box>
            <Typography sx={{ fontSize: "34px", fontWeight: "bold", marginTop: "20px" }}>Scan & Pay</Typography>
          </Box>
        </Box>

      </Box>


    </>
  );
};

export default HomePage;

